import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";
import { Metadata } from "@/view/ContentHead";

const useContentMetadataGet = (contentId: string | null) => {
  const requestUrl = `${API_BASE_URL}/api/v3/content-document/${contentId}/metadata/`;
  return useRestQuery<Metadata[]>(requestUrl, { skip: !contentId });
};

export default useContentMetadataGet;
